import React from 'react';
import { Box, SxProps } from '@mui/material';

type PageWrapperProps = {
  children: React.ReactNode;
  sx?: SxProps;
};

const PageWrapper: React.FC<PageWrapperProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        mt: { xs: '70px', sm: '50px', md: '60px' },
        p: { xs: 1, md: 2, lg: 4 },
        backgroundColor: 'backgroundLight.primary',
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default PageWrapper;